import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDataIaStyles } from "../styles/data-artificial-intelligence";
import DebriefingService from "../../services/DebriefingService";
import CheckListService from "../../services/CheckListService";
import { SheAiVideoProvider, useSheAiVideo } from '../../contexts/SheAiVideoContext';
import ChecklistAiPanel from "./modules/ChecklistAiPanel";
import type { ChecklistIntegro } from "./modules/ChecklistIntegroSection";

function DataIa({ idEvaluated, idDebriefing, checklistId }: any) {
  const styles = useDataIaStyles();
  // O JSON da análise NÃO carrega o enunciado dos Itens: `merge_item_metadata`
  // no agente devolve `value`, `skill` e `critical`, mas não `question`. Sem
  // esta junção o relatório sairia com "Item 519" onde deve estar a pergunta
  // que o professor escreveu. A correção definitiva é o agente ecoar
  // `question` no resultado — enquanto não ecoa, a tela junta.
  const [perguntaPorItem, setPerguntaPorItem] = useState<Record<string, string>>({});
  // O mesmo fetch também alimenta a sub-aba "Checklist" da aba Dados IA: o
  // instrumento na íntegra (enunciado + Detecção) é o que a IA recebeu.
  const [checklistIntegro, setChecklistIntegro] = useState<ChecklistIntegro | null>(null);


  // Substitui estados locais pelos do contexto
  const {
    video, setVideo,
    videoId, setVideoId,
    arrVideo, setArrVideo,
    cameraMain, setCameraMain
  } = useSheAiVideo();

  const loadDebriefingUrl = async (debriefingId: any) => {
    await DebriefingService.getDebriefingUrl(debriefingId)
      .then((response: any) => {
        //console.log("Response debriefing URL:", response);
        if (response) {
          if (response.data.length > 0
            //  &&
            // response.data[0].field_name != "debriefing_video"
          ) {
            setVideo(response.data[0]?.recording_url);
            setVideoId(response.data[0]?.streaming_id);
            const cameraDefault = response.data[0]?.camera_main ? true : false;
            setCameraMain(cameraDefault);
            setArrVideo(response.data);
          } else {
            setVideo(response.data[0]?.static_url);
            setVideoId(response.data[0]?.id);
            setCameraMain(true);
          }
        }
      })
      .catch((e: Error) => {});
  };

  const loadPerguntas = async (checklistId: any, debriefingId: any) => {
    try {
      const resposta: any = await CheckListService.getChecklistDebriefing(
        checklistId,
        debriefingId
      );
      const mapa: Record<string, string> = {};
      (resposta?.data?.skills || []).forEach((skill: any) =>
        (skill.items || []).forEach((item: any) => {
          if (item.question) mapa[String(item.item_id)] = item.question;
        })
      );
      setPerguntaPorItem(mapa);
      setChecklistIntegro(resposta?.data ?? null);
    } catch (e) {
      setPerguntaPorItem({});
      setChecklistIntegro(null);
    }
  };

  useEffect(() => {
    if (idDebriefing) {
      loadDebriefingUrl(idDebriefing);
    }
    if (checklistId && idDebriefing) {
      loadPerguntas(checklistId, idDebriefing);
    }
  }, [idEvaluated, idDebriefing, checklistId]);

  return (
    <Box className={styles.containerIa}>
      {/* A análise da IA sobre o vídeo é o conteúdo principal desta aba, e vem
          primeiro. Antes ela era a última seção, atrás de três módulos que na
          maioria dos debriefings mostram erro de foto de perfil, `not_found`
          de STT e "nenhum arquivo encontrado" — o professor rolava por três
          avisos vazios para chegar no que interessa.

          A transcrição entra como sub-aba do painel, produzida pelo PRÓPRIO
          agente ADK (audio_asr_agent) — mesma fonte das Soft Skills e do
          Dossiê, sem o STT legado que divergia do áudio. */}
      <ChecklistAiPanel
        debriefingId={idDebriefing}
        styles={styles}
        perguntaPorItem={perguntaPorItem}
        checklist={checklistIntegro}
        videoUrl={video}
      />
    </Box>
  );
}

// Envolva o componente DataIa com o provider para garantir que o contexto de vídeo esteja disponível
// Isso permite que todos os módulos SHEAI acessem video, videoId, arrVideo e cameraMain de forma centralizada
const DataIaWithProvider = (props: any) => (
  <SheAiVideoProvider>
    <DataIa {...props} />
  </SheAiVideoProvider>
);

export default DataIaWithProvider;
